export default __webpack_public_path__ + "static/media/silence.630c7671.mp3";